import { Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { getI18t } from "src/pages/i18n/i18n";

const TimeWindowGroupSelection = memo(
  (props: {
    timeWindowGroupList: TimeWindowGroup[];
    onSelect: (timeWindowGroup: TimeWindowGroup) => void;
    onCreateNew: () => void;
    isMobile: boolean;
  }): JSX.Element => {
    const selections = props.timeWindowGroupList.map((twg) => (
      <Button
        key={twg.id}
        onClick={() => {
          props.onSelect(twg);
        }}
      >
        {twg.idOnDevice}{twg.name.trim() != "" ? `. ${twg.name.trim()}` : ""}
      </Button>
    ));
    const t = getI18t(
      useTranslation(undefined, {
        keyPrefix: "inApp.timeWindowGroupList.timeWindowGroupSelection",
      }).t
    );

    return (
      <div
        className={
          "grid gap-2 w-full z-" +
          (props.isMobile ? " grid-cols-2" : " grid-cols-4")
        }
      >
        {selections}
        <Button
          variant={"light"}
          onClick={props.onCreateNew}
          leftSection={<IconPlus />}
        >
          {t("add")}
        </Button>
      </div>
    );
  }
);
TimeWindowGroupSelection.displayName = "TimeWindowGroupSelection";

export default TimeWindowGroupSelection;
